import { TextField } from '@mui/material';
import debounce from '@mui/utils/debounce';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { format, isMatch } from 'date-fns';
import { DATE_FORMAT } from '../lib/date_time';
import { useState } from 'react';
import { useUserConfiguration } from '../providers/UserConfigurationProvider';

interface TftSelectDateProps {
  onDateSelected: (dateString: string) => void;
  label?: string;
  disableFutureDate?: boolean;
  disabled?: boolean;
  value?: string;
}

export function TftSelectDate(props: TftSelectDateProps) {
  const {
    onDateSelected,
    label,
    disableFutureDate = false,
    disabled = false,
    value,
  } = props;
  const { globalDateFormat } = useUserConfiguration();
  const [dateValue, setDateValue] = useState(value);
  const updateUpwards = debounce((date: string) => {
    onDateSelected(date);
  }, 500);
  const onChangeDate = (values: string) => {
    if (isMatch(values, DATE_FORMAT)) {
      updateUpwards(values);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DesktopDatePicker
        value={dateValue ? dateValue : null}
        label={label ?? undefined}
        onChange={(newValue) => {
          if (newValue) {
            const formatDate = format(new Date(newValue), DATE_FORMAT);
            if (dateValue) setDateValue(formatDate);
            onChangeDate(formatDate);
          }
        }}
        disableFuture={disableFutureDate}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{ width: 140 }}
            id="date"
            variant="standard"
            inputProps={{ ...params.inputProps, readOnly: true }}
            size="small"
            fullWidth={false}
            InputLabelProps={{
              shrink: true,
            }}
          />
        )}
        inputFormat={globalDateFormat.split(' ')[0]}
      />
    </LocalizationProvider>
  );
}
